module.exports = __webpack_public_path__ + "img/m-churukumingxi.ea649304.svg";